module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "wordsection"
  }, [_c('p', {
    staticClass: "msonormal1",
    attrs: {
      "id": "textblock_pb_0"
    }
  }, [_c('i', {
    staticClass: "textblock2"
  }, [_c('span', {
    staticClass: "textblock3",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("If Only For One Night")])]), _vm._v(" "), _c('span', {
    staticClass: "textblock3",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("© 2018 by ReShonda Tate Billingsley, Victoria Christopher Murray")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal2"
  }, [_c('span', {
    staticClass: "textblock3",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("Brown Girls Books LLC")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal2"
  }, [_c('span', {
    staticClass: "textblock3",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_c('a', {
    staticClass: "ptextblock ptextblock1 textblock5",
    attrs: {
      "href": "http://www.BrownGirlsBooks.com",
      "target": "_blank"
    }
  }, [_vm._v("www.BrownGirlsBooks.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal2"
  }, [_c('span', {
    staticClass: "textblock3",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("ISBN: 978-1-944359-72-0 (ebook)")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal2"
  }, [_c('span', {
    staticClass: "textblock3",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("ISBN: "), _c('span', {
    staticClass: "textblock6"
  }, [_vm._v("978-1-944359-73-7")]), _vm._v(" (print)")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal3"
  }, [_c('span', {
    staticClass: "textblock3",
    attrs: {
      "xml:lang": "EN-US"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "msonormal3"
  }, [_c('span', {
    staticClass: "textblock3",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("All rights reserved. No part of this book may be reproduced in any form or by any means including electronic, mechanical or photocopying or stored in a retrieval system without permission in writing from the publisher except by a reviewer who may quote brief passages to be included in a review.")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal3"
  }, [_c('span', {
    staticClass: "textblock3",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("First Brown Girls Publishing LLC trade printing")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal3"
  }, [_c('span', {
    staticClass: "textblock3",
    attrs: {
      "xml:lang": "EN-US"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "msonormal3"
  }, [_c('span', {
    staticClass: "textblock3",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("Manufactured and Printed in the United States of America")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal3"
  }, [_c('span', {
    staticClass: "textblock3",
    attrs: {
      "xml:lang": "EN-US"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "msonormal3"
  }, [_c('span', {
    staticClass: "textblock3",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("If you purchased this book without a cover, you should be aware that this book is stolen property. It is reported as “unsold and destroyed” to the publisher, and neither the author nor the publisher has received any payment for this “stripped” book.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9f1d4e9a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/final_split_001.vue
// module id = 60
// module chunks = 0